import type { UpcomingArticlesSlice } from "@broadside/common";
import type { SliceProps } from "./SliceProps";
import Typography from "@mui/material/Typography";
import { css, styled } from "@mui/system";
import { useMediaQuery, useTheme } from "@mui/material";
import clsx from "clsx";
import { ArticleCard } from "../components/ArticleCard";
import { SliceTitle } from "./components";


const UpcomingArticlesRoot = styled("section")(({ theme }) => css`
	display: flex;
	flex-direction: column;
	gap: ${theme.spacing(1)};

	.articleList {
		display: flex;
		flex-direction: column;
		gap: ${theme.spacing(1)};
	}
	
	&.main {
		${theme.breakpoints.up("md")} {
			.articleList {
				display: grid;
				grid-template-columns: repeat(2, 1fr);
			}
			
			.highlight {
				grid-column: 1 / -1;
			}
		}
		
		${theme.breakpoints.up("lg")} {
			.articleList {
				width: 60ch;
			}
		}
	}

	.highlightArticles {
		display: flex;
		flex-direction: column;
	}
`);

export const Slice_UpcomingArticles = (p: SliceProps<UpcomingArticlesSlice>): JSX.Element | null => {
	const large = useMediaQuery(useTheme().breakpoints.up("md"));

	if(!p.slice.articles?.length) {
		return null;
	}

	const nextArticle = p.slice.articles[0]!;
	const articles = p.slice.articles.slice(1);

	const highlightNextArticle = p.slice.upcoming && large && p.position === "main";

	return (
		<UpcomingArticlesRoot className={ p.position }>
			<SliceTitle slice={ p.slice }/>
			{ p.slice.subtitle && (
				<Typography variant="h3">{ p.slice.subtitle }</Typography>
			) }

			<div className="articleList">
				<ArticleCard
					article={ nextArticle }
					className={ clsx({ highlight: highlightNextArticle }) }
					single={ highlightNextArticle }
				/>
				{ articles.map(article => <ArticleCard article={ article } key={ article.id }/>) }
			</div>
		</UpcomingArticlesRoot>
	);
};
